import React from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Grid, Input, Button, Image } from 'semantic-ui-react';

const Login = ({
  mobile,
  password,
  disabled,
  loading,
  onSubmit,
  onChanegOfMobile,
  onChangeOfPassword,
}) => {
  const isAuthenticated = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')) : false;
  if (isAuthenticated && isAuthenticated.accessToken) {
    return (<Redirect to="/home" />);
  }
  // console.log('disabled', disabled);
  return (
    <Grid centered container style={{ paddingTop: '15vh' }}>
      <Helmet>
        <title>Welcome to Daalchini </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={3} />
        <Grid.Column width={5}>
          <Image
            src="../../assets/Logo.png"
            size="small"
            rounded
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={3} />
        <Grid.Column width={5}>
          <h2>Welcome to Daalchini </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2}>
          <h4 style={{ paddingTop: '0.5em' }} >Mobile </h4>
        </Grid.Column>
        <Grid.Column width={6}>
          <Input
            placeholder="10-digit mobile number"
            style={{ width: '100%' }}
            value={mobile}
            disabled={loading}
            onChange={onChanegOfMobile}
            onKeyDown={onSubmit}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2}>
          <h4 style={{ paddingTop: '0.5em' }} >Password </h4>
        </Grid.Column>
        <Grid.Column width={6}>
          <Input
            type="password"
            placeholder="your super secret"
            style={{ width: '100%' }}
            value={password}
            disabled={loading}
            onChange={onChangeOfPassword}
            onKeyDown={onSubmit}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} />
        <Grid.Column width={4} >
          <Button
            data-actiontype="Submit"
            primary
            style={{ width: '100%' }}
            loading={loading}
            disabled={disabled}
            onClick={onSubmit}
          > Login
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/Modules/Login/component.jsx